import { FallbackRender } from '@sentry/react';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Container,
    Divider,
    Typography,
} from '@mui/material';

interface Props {
    resetError: () => void;
    error: unknown;
    componentStack: string;
    eventId: string;
}

export const ErrorComponent: FallbackRender = ({
    error,
    resetError,
}: Props) => {
    const { message, stack, name } = error as Error;

    return (
        <Container
            maxWidth="md"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            <Typography variant="h3" mb={2} color="error">
                Oh no something went wrong!
            </Typography>
            <Card sx={{ maxWidth: 800 }}>
                <CardHeader
                    title={`${name}: ${message}`}
                    sx={{ whiteSpace: 'break-space' }}
                    titleTypographyProps={{ color: 'error', variant: 'h6' }}
                />
                <Divider />
                <CardContent>
                    <Typography variant="body1">{stack}</Typography>
                </CardContent>
                <Divider />
                <CardActions sx={{ justifyContent: 'flex-end' }}>
                    <Button
                        // variant="outlined"
                        color="inherit"
                        onClick={() => {
                            resetError();
                            window.location.reload();
                        }}
                    >
                        Reset
                    </Button>
                </CardActions>
            </Card>
        </Container>
    );
};
